import React, { useRef, useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface PageLayoutProps {
  children: React.ReactNode;
  isBooking?: boolean;
  isLogin?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, isBooking = false, isLogin = false }) => {
  const footerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#030B32] text-white">
      {/* Navbar */}
      <Navbar footerRef={footerRef} isBooking={isBooking} isLogin={isLogin} />

      {/* Content with padding-top to prevent navbar overlap */}
      <div className="relative z-10 pt-[80px]">
        {/* Page-specific content */}
        {children}

        {/* Footer */}
        <Footer footerRef={footerRef} />
      </div>
    </div>
  );
};

export default PageLayout;